import type { PAGE_POSITIONS } from 'types';
import type { TrackableProduct } from 'types/TrackableProduct';
import type { User } from 'types/User';

import gtm from '~/services/gtm.client';
import {
  getEntrypoint,
  getPageType,
  getPreviousPagePath,
  getPreviousPagePosition,
  getPreviousPageType,
  getSourceAndMedium
} from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  affiliateName: string;
  buttonPosition?: number;
  clientIp?: string | null;
  isBot: boolean;
  isReseller?: boolean;
  pagePosition?: PAGE_POSITIONS;
  product?: TrackableProduct;
  retailerClickPrice?: number;
  retailerId?: string;
  user: User;
};

class AffiliateLinkClickEvent extends UserEvent<EventData> {
  protected get sendsBeforeTags(): boolean {
    return true;
  }

  sendToGtm() {
    gtm.pushToDataLayer({
      event: 'retailerLinkClick',
      retailer_name: this.getAffiliateName()
    });
  }

  collectServerEvents() {
    const { product } = this.data;

    this.serverEvents.push({
      data: {
        button_position: this.data.buttonPosition,
        client_ip_address: this.data.clientIp ?? '',
        entry_point: getEntrypoint(),
        is_logged_in: this.data.user.isLoggedIn,
        is_reseller: this.data.isReseller,
        page_path: window.location.pathname,
        page_position: this.data.pagePosition,
        page_type: getPageType(),
        platform: 'web' as const,
        previous_page_path: getPreviousPagePath(),
        previous_page_position: getPreviousPagePosition(),
        previous_page_type: getPreviousPageType(),
        product_brand: product?.brand,
        product_id: product?.product_id,
        product_name: product?.name,
        product_sub_brand: product?.sub_brand,
        product_view_price:
          product?.price?.sale ?? product?.price?.regular ?? undefined,
        retailer_click_price: this.data.retailerClickPrice,
        retailer_id: this.data.retailerId,
        retailer_name: this.getAffiliateName(),
        source_medium: getSourceAndMedium(),
        stock_status: product?.stock_status,
        style_code: product?.style_code
      },
      type: 'retailer_click'
    });
  }

  private getAffiliateName() {
    return this.data.affiliateName;
  }
}

export default AffiliateLinkClickEvent;
